var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSerachicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6355 24.8233C27.768 24.9156 27.9343 24.9987 28.059 25.1234C30.126 27.1809 32.1838 29.2475 34.2507 31.3037C34.8029 31.8531 35.1095 32.4857 34.964 33.2689C34.8172 34.0639 34.3482 34.6211 33.5778 34.8796C32.7853 35.1459 32.063 34.9653 31.4693 34.3886C30.4482 33.3936 29.4478 32.3779 28.4397 31.3699C27.2146 30.145 25.9921 28.9175 24.7488 27.6719C20.7981 30.5256 16.4577 31.4933 11.7223 30.3594C8.01588 29.4722 5.04215 27.4225 2.8453 24.3168C-1.57698 18.065 -0.761115 9.51942 4.71347 4.30814C10.2881 -0.997962 18.8052 -1.4396 24.8255 3.18847C31.1965 8.08671 33.0477 17.7611 27.6355 24.8233ZM15.3989 26.6548C21.6296 26.6613 26.6417 21.6696 26.6638 15.4373C26.6858 9.1908 21.6751 4.16006 15.421 4.14837C9.1955 4.13668 4.17692 9.13494 4.15743 15.3672C4.13795 21.6176 9.14873 26.6496 15.3989 26.6561V26.6548Z",
    fill: "#243B55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSerachicon);
export default __webpack_public_path__ + "static/media/serachicon.a84d2f937991f59057e17d33d8ac4be2.svg";
export { ForwardRef as ReactComponent };